/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/IDailyPyramidAuthority',[
    'SolitaireShared/PyramidLogic/PyramidAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/MoveState'
], function (PyramidAuthority, IDailyAuthority, CardOp, MoveState) {
    "use strict";

    var IDailyPyramidAuthority = function () {
        this.initIDailyPyramidAuthority();
    };

    var TAG_MOVEPERFORMED = 0x40000000;

    IDailyPyramidAuthority.constructor = IDailyPyramidAuthority;
    IDailyPyramidAuthority.prototype = Object.create(PyramidAuthority.prototype);
    IDailyAuthority.call(IDailyPyramidAuthority.prototype);

    IDailyPyramidAuthority.prototype.initIDailyPyramidAuthority = function () {
        PyramidAuthority.call(this);

        this.MovesAllowed = 0;

        this._startingTime = 0;

        this.ChallengeType = IDailyAuthority.ChallengeType.Unknown;

        this.DeckSeeds = [];

        this.IsChallenge = true;

        this.TotalMoves = 0;

        this.MaxDeals = PyramidAuthority.MAX_DEALS;
    };

    Object.defineProperty(IDailyPyramidAuthority.prototype, "TimerEnabled", {
        get: function () {
            return this._startingTime != 0;
        }
    });


    Object.defineProperty(IDailyPyramidAuthority.prototype, "StartingTime", {
        get: function () {
            return this._startingTime;
        },
        set: function (value) {
            this._startingTime = value;
            this.CardSupply.IsTimerCountdown = this._startingTime != 0;
        }
    });


    IDailyPyramidAuthority.prototype.GetStartingTime = function () {
        return this._startingTime;
    };


    IDailyPyramidAuthority.prototype.GetScoreForAction = function (action) {
        for (var i = 0; i < action.Ops.length; i++) {
            var op = action.Ops[i];
            if (this.MovesAllowed > 0 && action.GetActionUndoCount() == 0 && op.Opcode != CardOp.Op.Noop && op.Opcode != CardOp.Op.Deal) {
                action.Tag = (action.Tag | TAG_MOVEPERFORMED) >>> 0;
            }
        }

        return PyramidAuthority.prototype.GetScoreForAction.call(this, action);
    };

    IDailyPyramidAuthority.prototype.OnRunSpecialAction = function (tag, undo) {
        if (this.MovesAllowed > 0)
            this.TotalMoves += (undo ? -1 : 1);

        PyramidAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };

    IDailyPyramidAuthority.prototype.IsGameWon = function () {
        if (this.MovesAllowed > 0)
            return (PyramidAuthority.prototype.IsGameWon.call(this) && this.TotalMoves <= this.MovesAllowed + 1);
        else
            return PyramidAuthority.prototype.IsGameWon.call(this);
    };

    IDailyPyramidAuthority.prototype.CurrentMoveState = function () {
        if (this.MovesAllowed > 0) {
            if (this.TotalMoves > this.MovesAllowed + 1) {
                return MoveState.NoMovesLeft;
            }
            if (this.TotalMoves == this.MovesAllowed + 1) {
                if (this.IsGameWon()) {
                    return MoveState.CanMove;
                }
                return MoveState.NoMovesLeft;
            }
        }
        return PyramidAuthority.prototype.CurrentMoveState.call(this);
    };

    //#if !CHEATS
    IDailyPyramidAuthority.prototype.GetHint = function (cycle, cheat) {
        cycle = !!cycle;
        if(!cheat) {
            return new CardOp(this.CardSupply);
        } else {
            return PyramidAuthority.prototype.GetHint.call(this, cycle, cheat);
        }
    };

    //#endif
    IDailyPyramidAuthority.prototype.Deal = function () {
        if (!this.CardSupply.IsGamePageLoaded) {
            return PyramidAuthority.prototype.Deal.call(this);
        }
        this.TotalMoves = 0;

        if (this.DeckSeeds.length > 0)
            this.CardSupply.DeckSeed = this.DeckSeeds[0];

        return PyramidAuthority.prototype.Deal.call(this);
    };

    IDailyPyramidAuthority.prototype.SetDealScript = function (script) {
        this.DealScript = script;
    };

    IDailyPyramidAuthority.prototype.SetNumBoardsCompleted = function (numBoards) {
        this.NumBoardsCompleted = numBoards;
    };


    IDailyPyramidAuthority.prototype.GetIthDeckSeed = function (i) {
        if (!this.CardSupply.IsGamePageLoaded) {
            return PyramidAuthority.prototype.GetIthDeckSeed.call(this, i);
        }
        if (this.DeckSeeds.length > i)
            return this.DeckSeeds[i];
        return null;
    };

    return IDailyPyramidAuthority;


});
